import styled from 'styled-components'
import { Column, Row } from '@sainsburys-tech/bolt'

const MtoBadge = styled.div`
  margin-bottom: 8px;
`

const MediaWrapper = styled(Column)`
  margin-bottom: 15px;

  @media only screen and (min-width: ${props => props.theme.size.breakpoint['min-width'].md}) {
    margin: 0;
  }
`
const ProductBrandName = styled.span`
  display: block;
  font-size: ${props => props.theme.font.size['label-2']};
  font-weight: ${props => props.theme.font.weight['label-2']};
  margin-bottom: 10px;
`

const AttributeSelectorWrapper = styled.div`
  margin-bottom: 20px;
`

const Wrapper = styled(Row)`
  @media only screen and (min-width: ${props => props.theme.size.breakpoint['min-width'].md}) {
    margin-bottom: 40px;
  }
`

export { MediaWrapper, ProductBrandName, AttributeSelectorWrapper, Wrapper, MtoBadge }
